/*
* [字體大小自動調整插件]
* 
* 使用方式：在頁面中使用v-font-size指令，傳入規則物件或名稱
* 
*   1. 定義規則物件在頁面data中，在v-font-size中傳入
*   2. 在v-font-size中傳入匿名物件陣列
*   3. 在v-font-size中傳入規則物件"名稱"
*   4. 不傳參數或傳入"default"，使用預設規則
* 
*   註1：推薦使用方法1或2，參考範例
*   註2：沒符合的規則，會使用原本CSS內設定的字體大小
*   註3：changeSizeDigit的數字位數，不含標點符號
* 
* 規則屬性：
*
*   1. changeSizeDigit: 大於或等於此位數(不含標點符號)，將字體調整為fontSize
*   2. fontSize: 自動調整的字體大小(px)
* 
* 範例：
*   
*   1. 複雜的規則，定義規則物件在頁面data中，在v-font-size中傳入
*       <template>
*           <div v-font-size="testFontSizeSetting">12345678</div>
*       </template>
*       <script>
*           data() {
*               return { testFontSizeSetting: [{ changeSizeDigit: 10, fontSize: '24px' }, 其他規則... ] };
*           }
*       </script>
*
*   2. 簡單的規則，在v-font-size中傳入匿名物件陣列
*       <template>
*           <div v-font-size="[{ changeSizeDigit: 10, fontSize: '24px' }]">12345678</div>
*       </template>
*
*   3. 在v-font-size中傳入規則物件名稱，在presets中定義
*       <div v-font-size="'testRules'">12345678</div>
*
*   4. 不傳參數或傳入'default'，使用預設規則
*       4-1. <div v-font-size>12345678</div>
*       4-2. <div v-font-size="'default'">12345678</div>
*/

import Vue from 'vue';

// 字體大小規則定義
const presets = {
    default: [],
};

// 共用的字體大小更新邏輯
function updateFontSize(el, inputInfo) {
  // 取得元素的文字內容
  const content = el.textContent || '';
  // 計算純數字的位數(移除逗號、小數點、貨幣符號等)
  const length = content.replace(/[^\d]/g, '').length;
  
  let rules = [];
  
  if (typeof inputInfo.value === 'string') {
    // 傳入字串，尋找預先定義的規則
    rules = presets[inputInfo.value] || presets.default;
  } else if (Array.isArray(inputInfo.value)) {
    // 傳入陣列，使用頁面自訂規則
    rules = inputInfo.value;
  } else {
    // 使用預設規則
    rules = presets.default;
  }
  
  // 先清空，避免有舊style殘留
  let fontSize = '';
  
  if (rules){
    // 找符合位數的第一個規則，更改字體大小
    for (let rule of rules) {
      if (length >= rule.changeSizeDigit) {
        fontSize = rule.fontSize;
        break;
      }
    }
  }
  el.style.fontSize = fontSize;
}

// 註冊 Vue directive，建立自訂指令v-font-size
Vue.directive('font-size', {
  // 元素第一次出現在頁面
  inserted(el, binding) {
    updateFontSize(el, binding);
    // 監聽DOM內容變化（方便測試時手動修改HTML，不用改DB值）
    const observer = new MutationObserver(() => {
      updateFontSize(el, binding);
    });
    
    // 監聽"子元素和下層元素"、"文字內容"的變化
    observer.observe(el, {
      subtree: true,
      characterData: true
    });
    
    // 存儲observer以便後續清理
    el._fontSizeObserver = observer;
  },
  // computed或data更新內容後觸發
  componentUpdated(el, binding) {
    updateFontSize(el, binding);
  },
  // 當元素解綁時清理observer
  unbind(el) {
    if (el._fontSizeObserver) {
      el._fontSizeObserver.disconnect();
      delete el._fontSizeObserver;
    }
  }
});